export enum ShopProductLines {
  Review = 'Review',
  Tools = 'Tools',
  Research = 'Research',
  Rating = 'Rating',
  Events = 'Events',
}
